<template>
  <div>
    <PageHeader />

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card mb-3">
            <div class="row no-gutters">
              <div class="col-12">
                <div class="card-body">
                  <form id="form-proper">
                    <div class="row">
                      <div class="col">
                        <b-form-group label="Data Privacy Policy" label-size="lg">
                          <b-form-file
                            v-model="file"
                            :state="Boolean(file)"
                            :placeholder="formData.name ? formData.name : 'Choose a file or drop it here...'"
                            drop-placeholder="Drop file here..."
                            accept="application/pdf"
                            @change="beforeUpload"
                            size="lg"
                          ></b-form-file>
                          <div class="mt-3">Selected file: {{ formData.name ? formData.name : 'Not Configured' }}</div>
                        </b-form-group>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <b-button
                          size="sm"
                          variant="primary"
                          @click.prevent="createAccountPolicy"
                          :disabled="dpcFileUploading"
                          v-if="policyId == null || formData.file_path == null"
                        >
                          <span v-if="!dpcFileUploading">Save</span>
                          <span v-else
                            ><a-spin :spinning="dpcFileUploading" /> Submitting
                            ...</span
                          >
                        </b-button>
                        <b-button
                          size="sm"
                          variant="primary"
                          @click.prevent="updateAccountPolicy"
                          :disabled="dpcFileUploading"
                          v-else
                        >
                          <span v-if="!dpcFileUploading">Save Update</span>
                          <span v-else
                            ><a-spin :spinning="dpcFileUploading" /> Submitting
                            ...</span
                          >
                        </b-button>
                      </div>
                    </div>
                  </form>
                  <br>
                  <hr>
                  <div v-if="formData.file_path != null">
                    <iframe type="application/pdf"
                      :src="apiUrl + '/' + formData.file_path + '#toolbar=0&view=FitH'"
                      width="100%" height="500vh"></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
// import { required, requiredIf } from 'vuelidate/lib/validators';
import PageHeader from '@/components/Page/Header';

export default {
  name: 'DataPrivacyPolicy',
  components: {
    PageHeader
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_BASE_URL,
      file: null,
      formData: {
        name: null,
        type: 'DATA_PRIVACY_POLICY',
        file_path: null
      },
      dpcFileUploading: false,
      dpcChange: false,
      policyId: null
    };
  },

  methods: {
    async createAccountPolicy() {
      const response = await HTTPRequest.postRequest(
        '/api/v1/clp_account_policies',
        {
          account_policy: this.formData
        }
      );

      if (response.id) {
        this.policyId = response.id;
        this.$notification.success({
          message: 'Policy has been uploaded.'
        });

        this.$store.dispatch('setDataPrivacyPolicy', response);
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    },

    async updateAccountPolicy() {
      const response = await HTTPRequest.putRequest(
        '/api/v1/clp_account_policies/' + this.policyId,
        {
          account_policy: this.formData
        }
      );

      if (response.id) {
        this.$notification.success({
          message: 'Policy has been updated.'
        });

        this.$store.dispatch('setDataPrivacyPolicy', response);
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    },

    dpcFileOnchange(res) {
      if (res.status == false) {
        this.dpcFileUploading = false;
        this.$message.error('Unable to upload file. Please try again.');
      }

      if (res.status == true) {
        this.dpcFileUploading = false;
        if (
          res.response !== undefined ||
          res.response !== null ||
          res.response.status
        ) {
          this.formData.file_path = res.path;
          this.dpcChange = true;
        } else {
          this.$message.error('Unable to upload file. Please try again.');
        }
      }
    },

    async beforeUpload(event) {
      const file = event.target.files[0];
      this.dpcFileUploading = true;

      const isPdf = file.type === 'application/pdf';
      if (!isPdf) {
        this.$message.error('You can only upload PDF file!');
      } else {
        this.formData.name = file.name;
        const formData = new FormData();
        formData.append('data_privacy_policy', file);
        const response = await HTTPRequest.postRequest('/upload-file/data_privacy_policy', formData);
        this.dpcFileOnchange(response);
      }
    }
  },

  mounted() {
    if (this.$store.getters.getDataPrivacyPolicy != null) {
      this.policyId = this.$store.getters.getDataPrivacyPolicy.id;
      this.formData.name = this.$store.getters.getDataPrivacyPolicy.name;
      this.formData.file_path = this.$store.getters.getDataPrivacyPolicy.file_path;
    } else {
      this.policyId = null;
    }
  },

  watch: {
    '$store.getters.getDataPrivacyPolicy': function(obj) {
      this.policyId = obj.id;
      this.formData = {
        file_path: obj.file_path,
        name: obj.name
      };
    }
  }
};
</script>

<style scoped></style>
